import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { Investment, InvestmentsParams } from '../investments.interface';

export const setInvestments = createAction(
  '[Investments Component] Set Investments',
  props<{ investments: BackendResponse<Investment>; params: InvestmentsParams; pageNumber: number }>()
);

export const updateInvestments = createAction('[Investments Component] Update Investments', props<{ investments: Investment[] }>());

export const updateManyInvestment = createAction(
  '[Investments Component] Update many Investments',
  props<{ investments: { ids: string[]; changes: Partial<Investment> } }>()
);

export const switchAdvancedOptions = createAction('[Investments Component] Switch Advanced Options');

export const switchSelection = createAction('[Investments Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Investments Component] Switch All Selection', props<{ checked: boolean }>());

export const setPNR = createAction('[Investments Component] Set PNR', props<{ pnr: string; userId: string }>());

// Requests

export const loadInvestments = createAction(
  '[Request/Api Investments] Load Investments',
  (params: InvestmentsParams, pageNumber: number = 1, notification?: string) => ({ params, pageNumber, notification })
);

export const changeInvestmentsStatus = createAction(
  '[Request/Api Investments] Change Investments Status',
  props<{ payload: { ids: string[]; status: string } }>()
);
